module.exports = __webpack_public_path__ + "img/exclamation.73569bf8.svg";